<template>
  <div class="rule-wrapper">
    <div class="form-item-blue">
      <van-divider :style="{ color: '#fff', padding: '0 16px' }">活动规则</van-divider>
    </div>
    <div class="rule-content">
      <div class="rule-item">
        <div class="title">一、使用规则</div>
        <div class="desc">1、本活动仅限未注册便捷青岛APP、隧e通APP、琴岛通APP的新用户参与；</div>
        <div class="desc">2、活动期间，未注册用户进入活动页面完成注册即可领取一张价值9元的“隧e通”隧道通行券；</div>
        <div class="desc">3、每次通行只可使用1张优惠券；</div>
        <div class="desc">4、优惠券不兑现、不找零、不开具发票，数量有限，发完即止。</div>
      </div>
      <div class="rule-item">
        <div class="title">二、使用方法</div>
        <div class="desc">1、新用户须在上方文本框输入手机号，获取验证码注册。（注册成功后系统将自动发放一张价值9元的隧道通行优惠券到您的注册账户）；</div>
        <div class="desc">2、下载“便捷青岛”APP，使用注册手机号登录；</div>
        <div class="desc">3、登录“便捷青岛”APP，首页点击“隧e通”图标，在“车辆管理”中添加车辆，通过认证；</div>
        <div class="desc">4、点击“充值”（最低充值额度为20元）；</div>
        <div class="desc">5、选择ETC车道通行时，优惠券自动抵扣，每次只可抵扣1张优惠券（车辆通行胶州湾隧道ETC车道时，需提前关闭ETC拔出通行卡）。</div>
      </div>
      <div class="rule-item">
        <div class="title">三、活动时间</div>
        <!-- <div class="desc">优惠券发放时间：即日起至2020年9月30日；</div> -->
        <div class="desc">优惠券使用时间：自领取之日起30日内有效。</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Divider } from 'vant'

export default {
  components: {
    [Divider.name]: Divider
  }
}

</script>
<style lang='scss' scoped>
.rule-wrapper {
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  margin-bottom: 10px;
  background-image: linear-gradient(0deg, #4e99ff 0%, #00a2ff 100%);
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    line-height: 30px;
  }
}
.rule-content {
  padding: 0 15px 15px 15px;
  background: #fff;
  border-radius: 10px;
}
.rule-item {
  .title {
    font-size: 14px;
    margin: 15px 0 6px;
    color: #282828;

  }
  .desc {
    line-height: 1.6;
    font-size: 12px;
    color: #999;
  }
}

</style>
